import { useEffect, useState } from "react";

export function useHoverSupported(): boolean {
  const [supported, setSupported] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      setSupported(false);
      return;
    }
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    const update = () => setSupported(mq.matches);
    update();
    if (mq.addEventListener) {
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    }
    mq.addListener(update);
    return () => mq.removeListener(update);
  }, []);
  return supported;
}
